import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { ShippingService } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShippingServiceService extends TmsWebBaseEditCreateService<ShippingService, ShippingService> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShippingService', $localize`Shipping Service`, httpService, notificationService);
  }

  getForSupplier(id: string): Observable<ShippingService[]> {
    return this.httpService.get<ShippingService[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }
}
